const ModalWrap =({children})=>{
    return(
    <div className="authorization-popup">
        {children}
  </div>)
}

export default ModalWrap